import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import dropdown from "../../../assets/common/dropdown.svg";
import shield from "../../../assets/common/shield.svg";
import plusLine from "../../../assets/common/plusLine.svg";
import minusLine from "../../../assets/common/minusLine.svg";
import trash from "../../../assets/common/trash.svg";
import {
  PopupForm,
  Button,
  GenericDiv,
  RespFont,
  FlexRowBetween,
  DropOption,
  Input,
  Label,
} from "../../common/Style";
import OpacityLoading from "../../common/loader/OpacityLoading";
import { CFV, addAlpha } from "../../common/others/Functions";
import { toast } from "react-toastify";
import { addMany } from "../../../store/reducers/guestsReducer";
import OWC from "./OWC";

// const inputs = {
//     "0": true, "1": true, "2": true, "3": true, "4": true, "5": true, "6": true, "7": true, "8": true, "9": true,
//     "10": true, "11": true, "12": true, "13": true, "14": true, "15": true, "16": true, "17": true, "18": true, "19": true
// }
const inputs = {};
const inputsErrors = {};
const AddGuests = (props) => {
  let height = window.screen.availHeight;
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [amount, setAmount] = useState(1);
  const { user } = useSelector((state) => state.authReducer);
  const [inviting, setInviting] = useState("");
  const defaultPreSms1 = `${user.brideFN + " " + user.brideLN} ו${
    user.groomFN + " " + user.groomLN
  } שמחים להזמינכם לחתונתם!`;
  const [closeness, setCloseness] = useState("");
  const [flag, setFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [show, setShow] = useState(true);
  const [owc, setOwc] = useState("קשר");
  const [showDropOwc, setShowDropOwc] = useState(false);
  const [animate, setAnimate] = useState(
    "animate__animated animate__heartBeat animate__infinite"
  );
  const handleOnSelect = (item) => {
    setCloseness(item.id);
  };
  const handleOnSearch = (string, results) => {
    setCloseness(string);
  };

  const digitOrNull = (value) =>
    parseInt(value) >= 0 ? parseInt(value) : null;

  const onSubmit = async (data) => {
    setChecked(false);
    let rows = [
      ["שם מלא", "טלפון", "קירבה", "מוזמנים", "אישרו", "מזמין", "קשר", "מספר"],
    ];
    let newOwc = "";
    if (
      user.eventType &&
      ((inviting?.length > 0 && owc === "קשר") ||
        (inviting?.length === 0 && owc !== "קשר"))
    )
      toast.warning("שדה המזמין והקשר באים ביחד - הכל או כלום");
    else if (closeness.length > 1) {
      newOwc = owc;
      for (let i = 0; i < amount; i++) {
        if (inputs[i] !== false)
          rows.push([
            data[`${i}name`],
            data[`${i}phone`].length ? data[`${i}phone`] : null,
            closeness,
            digitOrNull(data[`${i}sum`]),
            digitOrNull(data[`${i}accept`]),
            inviting,
            newOwc === "קשר" ? "" : newOwc,
            i + 1,
          ]);
      }
      if (rows.length === 1) toast.warning("לא נבחרו רשומות להוספה");
      else {
        dispatch(addMany({ rows })).then((res) => {
          setChecked(true);
          if (!res.payload?.error) {
            toast.success("הפעולה בוצעה בהצלחה!!");
            setTimeout(function () {
              setLoading(false);
              props.init();
            }, 2000);
          } else {
            setLoading(false);
            toast.error("לא כל הרשומות נטענו בהצלחה, ראו פירוט בכל שורה");
            for (let i = 0; i < amount; i++) inputs[i] = false;
            for (let i = 0; i < res.payload?.error.length; i++) {
              inputs[res.payload?.error[i]["מספר"] - 1] = true;
              inputsErrors[res.payload?.error[i]["מספר"] - 1] =
                res.payload?.error[i]["סיבה"];
            }

            setFlag(!flag);
          }
        });
      }
    } else toast.warning("שדה קירבה לא יכול להיות פחות מ 2 תווים");
  };

  let guestsArray = useMemo(() => {
    let guests = [];
    for (let i = 0; i < amount; i++) {
      guests.push(
        <div
          key={i}
          style={{
            display: checked && inputs[i] === false ? "none" : "flex",
            flexDirection: "column",
            width: "94%",
            margin: "0 auto",
            padding: "16px 18px",
            backgroundColor: "#f8f9fa",
            marginTop: "12px",
            borderRadius: "8px",
            paddingTop: "16px",
            border: "1px solid #e8e8e8",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
          }}
        >
          <FlexRowBetween style={{ marginTop: "10px" }}>
            <div style={{ position: "relative", width: "50%" }}>
              <Input
                style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
                placeholder={"שם מלא"}
                type="text"
                onFocus={(e) => {
                  e.target.style.borderColor = "#7b96c4";
                  e.target.style.boxShadow = "0 0 0 3px rgba(123, 150, 196, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.boxShadow = "none";
                }}
                {...register(`${i}name`, {
                  required: true,
                  minLength: 2,
                  maxLength: 50,
                })}
              />
              {CFV(`${i}name`, "בין 2 ל 50 תווים", errors)}
            </div>
            <div style={{ position: "relative", width: "40%" }}>
              <Input
                style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
                placeholder={"מס׳ נייד"}
                type="text"
                onFocus={(e) => {
                  e.target.style.borderColor = "#7b96c4";
                  e.target.style.boxShadow = "0 0 0 3px rgba(123, 150, 196, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.boxShadow = "none";
                }}
                {...register(`${i}phone`, {
                  pattern: /^[0]{0,1}[5]{1}[0-9]{8}$/,
                })}
              />
              {CFV(`${i}phone`, "פורמט מספר פלאפון לא חוקי", errors)}
            </div>
          </FlexRowBetween>
          <FlexRowBetween
            style={{ marginTop: "10px", alignItems: "flex-start" }}
          >
            <div style={{ position: "relative", width: "30%" }}>
              <Input
                style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
                placeholder={"כמות"}
                type="number"
                onFocus={(e) => {
                  e.target.style.borderColor = "#7b96c4";
                  e.target.style.boxShadow = "0 0 0 3px rgba(123, 150, 196, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.boxShadow = "none";
                }}
                {...register(`${i}sum`, {
                  required: true,
                  min: 1,
                  max: props.acceptLimit,
                })}
              />
              {CFV(`${i}sum`, `מספר בין 1 ל ${props.acceptLimit}`, errors)}
            </div>
            <div style={{ position: "relative", width: "30%" }}>
              <Input
                style={{
                  padding: "8px 12px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  backgroundColor: "#ffffff",
                  transition: "all 0.2s ease",
                }}
                placeholder={"אישרו"}
                type="number"
                onFocus={(e) => {
                  e.target.style.borderColor = "#7b96c4";
                  e.target.style.boxShadow = "0 0 0 3px rgba(123, 150, 196, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e0e0e0";
                  e.target.style.boxShadow = "none";
                }}
                {...register(`${i}accept`, {
                  min: 0,
                  max: props.acceptLimit,
                })}
              />
              {CFV(`${i}accept`, `מספר בין 0 ל ${props.acceptLimit}`, errors)}
            </div>

            {checked && inputs[i] && (
              <OverlayTrigger
                placement={"bottom"}
                trigger={["hover", "focus", "click"]}
                overlay={
                  <Tooltip>
                    {inputsErrors[i] !== undefined && inputsErrors[i] !== ""
                      ? inputsErrors[i]
                      : "רשומה זו נכנסה בהצלחה!"}
                  </Tooltip>
                }
              >
                {inputsErrors[i] !== undefined && inputsErrors[i] !== "" ? (
                  <button
                    type="button"
                    style={{
                      background:
                        "linear-gradient(135deg, #ffc107 0%, #ff9800 100%)",
                      color: "#ffffff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 12px",
                      fontSize: "13px",
                      fontWeight: "700",
                      fontFamily: "system-ui, -apple-system, sans-serif",
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                      animation: "errorBlink 0.9s infinite ease-in-out",
                      boxShadow: "0 0 10px rgba(255, 152, 0, 0.7)",
                    }}
                  >
                    שגיאה
                  </button>
                ) : (
                  <img
                    src={shield}
                    alt="success"
                    style={{ width: "30px" }}
                    className={animate}
                  />
                )}
              </OverlayTrigger>
            )}
          </FlexRowBetween>
        </div>
      );
    }

    return [guests];
  }, [flag, amount, errors, checked, inputs]);

  return (
    <PopupForm
      onSubmit={handleSubmit(onSubmit)}
      style={{ height: "min-content", maxHeight: `${height * 0.8}px` }}
      onClick={(e) => e.stopPropagation()}
    >
      <FlexRowBetween
        style={{
          width: "90%",
          margin: "10px auto",
          marginTop: "30px",
          alignItems: "flex-end",
        }}
      >
        <div
          className="relativeBox"
          style={{
            zIndex: "1",
            width: "65%",
          }}
        >
          <Label>קירבה</Label>
          <ReactSearchAutocomplete
            items={props.categories}
            onSelect={handleOnSelect}
            autoFocus
            onSearch={handleOnSearch}
            fuseOptions={{ minMatchCharLength: 1 }}
            maxResults={show ? 10 : 0}
            showNoResults={false}
            styling={{
              searchIconMargin: "0 5px 0 10px",
              borderRadius: "5px",
              width: "100%",
              height: "40px",
              fontFamily: "heb",
            }}
          />
        </div>
        <OverlayTrigger
          placement={"bottom"}
          overlay={
            <Tooltip>
              {show ? "הסתרת השלמות לחיפוש" : "הצגת השלמות לחיפוש"}
            </Tooltip>
          }
        >
          <div
            style={{
              backgroundColor: "#7b96c4",
              color: "#ffffff",
              padding: "10px 18px",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              fontSize: "14px",
              fontWeight: "400",
              fontFamily: "system-ui, -apple-system, sans-serif",
              boxShadow: "0 1px 3px rgba(123, 150, 196, 0.3)",
            }}
            onClick={() => setShow(!show)}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#6a87b3";
              e.currentTarget.style.boxShadow = "0 2px 6px rgba(123, 150, 196, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#7b96c4";
              e.currentTarget.style.boxShadow = "0 1px 3px rgba(123, 150, 196, 0.3)";
            }}
          >
            {show ? "הסתר" : "הצג"}
          </div>
        </OverlayTrigger>
      </FlexRowBetween>

      {user.eventType && (
        <FlexRowBetween
          style={{
            width: "90%",
            margin: "10px auto",
            marginBottom: "20px",
            alignItems: "flex-end",
          }}
        >
          <div style={{ position: "relative", width: "65%" }}>
            <div>
              <Label>המזמין</Label>
              <RespFont
                psize={"12px"}
                csize={"14px"}
                style={{ textAlign: "right" }}
              >
                (במידה ואלו מוזמנים של הזוג יש לדלג על שורה זו)
              </RespFont>
            </div>
            <Input onChange={(e) => setInviting(e.target.value)} type="text" />
          </div>
          <OverlayTrigger
            placement={"top"}
            overlay={<Tooltip>{"הקשר של בעל/ת השמחה למזמין"}</Tooltip>}
          >
            <div
              style={{
                backgroundColor: "#7b96c4",
                color: "#ffffff",
                padding: "10px 18px",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "all 0.2s ease",
                fontSize: "14px",
                fontWeight: "400",
                fontFamily: "system-ui, -apple-system, sans-serif",
                boxShadow: "0 1px 3px rgba(123, 150, 196, 0.3)",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginTop: "7px",
                position: "relative",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setShowDropOwc(!showDropOwc);
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#6a87b3";
                e.currentTarget.style.boxShadow = "0 2px 6px rgba(123, 150, 196, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#7b96c4";
                e.currentTarget.style.boxShadow = "0 1px 3px rgba(123, 150, 196, 0.3)";
              }}
            >
              <span>{owc}</span>
              <img
                src={dropdown}
                alt={"dropdown"}
                style={{ width: "20px", height: "20px", filter: "brightness(0) invert(1)" }}
              />
              {showDropOwc && (
                <OWC setOwc={setOwc} setShowDropOwc={setShowDropOwc} />
              )}
            </div>
          </OverlayTrigger>
        </FlexRowBetween>
      )}
      {user.eventType && (
        <FlexRowBetween
          style={{ width: "90%", margin: "0 auto", marginBottom: "20px" }}
        >
          <RespFont>
            {inviting !== "" && owc !== "קשר" ? (
              inviting +
              (owc[owc.length - 1] === "ם"
                ? " שמחים"
                : owc[owc.length - 1] === "ו"
                ? " שמח"
                : " שמחה") +
              " להזמינכם לחתונת " +
              owc +
              (owc.includes("ת") ? ` ${user.brideFN}.` : ` ${user.groomFN}.`)
            ) : (
              <>ברירת מחדל: {defaultPreSms1}</>
            )}
          </RespFont>
        </FlexRowBetween>
      )}

      {guestsArray[0]}
      <FlexRowBetween style={{ width: "90%", margin: "20px auto" }}>
        <OverlayTrigger
          placement={"bottom"}
          overlay={<Tooltip>{"הוספת שורה"}</Tooltip>}
        >
          <div
            style={{
              backgroundColor: "#7b96c4",
              color: "#ffffff",
              padding: "10px 14px",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 1px 3px rgba(123, 150, 196, 0.3)",
            }}
            onClick={() => {
              if (amount < 50) setAmount(amount + 1);
              else toast.warning("לא ניתן להוסיף יותר מ 50 רשומות כל פעם");
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#6a87b3";
              e.currentTarget.style.boxShadow = "0 2px 6px rgba(123, 150, 196, 0.4)";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#7b96c4";
              e.currentTarget.style.boxShadow = "0 1px 3px rgba(123, 150, 196, 0.3)";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <img
              src={plusLine}
              alt="plusLine"
              style={{ width: "22px", height: "22px", filter: "brightness(0) invert(1)" }}
            />
          </div>
        </OverlayTrigger>
        <Button
          style={{
            margin: "0 20px",
            width: "100%",
            background: "#7b96c4",
            color: "#ffffff",
            border: "none",
            borderRadius: "8px",
            padding: "12px 24px",
            fontSize: "15px",
            fontWeight: "400",
            fontFamily: "system-ui, -apple-system, sans-serif",
            cursor: "pointer",
            transition: "all 0.2s ease",
            boxShadow: "0 1px 3px rgba(123, 150, 196, 0.3)",
          }}
          type="submit"
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#6a87b3";
            e.currentTarget.style.boxShadow = "0 2px 6px rgba(123, 150, 196, 0.4)";
            e.currentTarget.style.transform = "translateY(-1px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#7b96c4";
            e.currentTarget.style.boxShadow = "0 1px 3px rgba(123, 150, 196, 0.3)";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          אישור
        </Button>
        <OverlayTrigger
          placement={"bottom"}
          overlay={<Tooltip>{"מחיקת שורה"}</Tooltip>}
        >
          <div
            style={{
              backgroundColor: "#6a7a8a",
              color: "#ffffff",
              padding: "10px 14px",
              borderRadius: "8px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 1px 3px rgba(106, 122, 138, 0.3)",
            }}
            onClick={() => {
              if (amount > 1) setAmount(amount - 1);
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#5a6a7a";
              e.currentTarget.style.boxShadow = "0 2px 6px rgba(106, 122, 138, 0.4)";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#6a7a8a";
              e.currentTarget.style.boxShadow = "0 1px 3px rgba(106, 122, 138, 0.3)";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <img
              src={minusLine}
              alt="minusLine"
              style={{ width: "22px", height: "22px", filter: "brightness(0) invert(1)" }}
            />
          </div>
        </OverlayTrigger>
      </FlexRowBetween>
      <div style={{ height: "10px" }}></div>
      {loading && <OpacityLoading />}
      <style>
        {`
          @keyframes errorBlink {
            0%, 100% {
              opacity: 1;
              transform: scale(1);
              box-shadow: 0 0 8px rgba(255, 152, 0, 0.6);
            }
            50% {
              opacity: 0.75;
              transform: scale(1.08);
              box-shadow: 0 0 18px rgba(255, 152, 0, 1);
            }
          }
        `}
      </style>
    </PopupForm>
  );
};

export default AddGuests;
